import { memo, useMemo } from 'react';

import { Chip, typographyVariants } from '@mint-lib/tw-components';

import { CHANNELS_AND_CATEGORIES } from '../../../constants/ComponentsConstants.jsx';
import { Platform } from '../../../types/index.js';
import { snakeCaseToCamelCase } from '../../../utils/snakeCaseToCamelCase.js';
import PlatformIcon from '../PlatformIcon/index.js';

type Props = {
  integration: Platform;
};

const IntegrationLogoWithType = ({ integration }: Props) => {
  const platformCategory = snakeCaseToCamelCase(integration?.category || '');
  const categoryProps = useMemo(
    () => CHANNELS_AND_CATEGORIES[platformCategory],
    [platformCategory],
  );

  if (!integration) {
    return <div className="block h-[88px]" />;
  }

  return (
    <div className="mb-2 flex">
      <PlatformIcon logo={integration?.logo} counter={0} />
      <div className="ml-2">
        <h2 className={typographyVariants({ variant: 'h2' })}>
          {integration?.label}
        </h2>
        <Chip color={'silver'} variant="outline">
          {categoryProps?.chipProps?.iconComponent}
          {categoryProps?.label}
        </Chip>
      </div>
    </div>
  );
};

export default memo(IntegrationLogoWithType);
